export default __webpack_public_path__ + "static/media/Inter-BlackItalic.c769882b.woff";